import { HOW_IT_WORKS_STEPS } from '../constants/content';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export default function HowItWorks() {
  const ref = useScrollAnimation();

  return (
    <section id="how-it-works" ref={ref} className="fade-in bg-[#F4F0FF] py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <h2 className="font-[Nunito] text-3xl font-extrabold text-[#5B3FA6] md:text-4xl">Up and running in 3 minutes</h2>
        <div className="relative mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {HOW_IT_WORKS_STEPS.map((step, index) => (
            <article key={step.number} className="relative rounded-2xl bg-white p-6 shadow-sm" style={{ transitionDelay: `${index * 100}ms` }}>
              <p className="font-[Nunito] text-4xl font-extrabold text-[#D7CCF6]">{step.number}</p>
              <p className="mt-3 text-3xl">{step.icon}</p>
              <h3 className="mt-4 font-[Nunito] text-xl font-bold text-[#4A3F66]">{step.title}</h3>
              <p className="mt-3 text-[#6F655E]">{step.description}</p>
              {index < HOW_IT_WORKS_STEPS.length - 1 && (
                <span className="absolute -right-4 top-1/2 hidden h-0 w-8 border-t-2 border-dashed border-[#C8B9EF] lg:block" />
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

